export const SUBSCRIPTION_LIMIT_KEYS = Object.freeze({
  PRODUCT_ITEMS: "productItems",
  SERVICE_ITEMS: "serviceItems",
  IMAGES_PER_ITEM: "imagesPerItem",
  STORES: "stores",
  NOTEBOOK_PAGES: "notebookPages",
});

export const REQUIRED_SUBSCRIPTION_LIMIT_KEYS = Object.freeze(
  Object.values(SUBSCRIPTION_LIMIT_KEYS)
);
